// extracted by mini-css-extract-plugin
export default {"container":"custom-modal_container__54ztA","header":"custom-modal_header__94wHh"};